var coupons = {};
coupons.inited = false;
const logs = require("@/classes/logs/logs.js").Logs;
coupons.init = async function(parent) {
  this.parent = parent;
  coupons.getPlans();
  setTimeout(coupons.getCustomer, 500);
  coupons.parent.pageLoading = false;
  // coupons.add("basic_monthly", "test 1", 1)
  //coupons.del("CbtMOSE5")
};
coupons.getPlans = function() {
  logs.print("getPlans");
  coupons.parent.adminUser.sendToServer(
    "get",
    "/plans",
    function(res) {
      logs.print("coupons.plans", res);
      if (res.status) {
        coupons.parent.plans = res.data;
      } else {
        console.error("coupons.getPlans", res.error_msg);
      }
    },
    function() {}
  );
};
coupons.removeCoupon = function(id) {
  var list = coupons.parent.list;
  for (var i = 0; i < list.length - 1; i++) {
    if (list[i].id === id) {
      list.splice(i, 1);
    }
  }
};
coupons.sendInvoice = function(coupon) {
  coupons.parent.adminUser.sendToServer(
    "put",
    "/coupons/sendInvoice/" + coupon,
    function(res) {
      logs.print("coupons.sendInvoice", res);
      if (res.status) {
        coupons.parent.$toastr(
          "success",
          coupons.parent.lang.invoice_sent_success
        );
      } else {
        coupons.parent.$toastr("error", coupons.parent.lang[res.error_msg]);
      }
      coupons.parent.pageLoading = false;
    },
    function() {}
  );
};
coupons.del = function(id) {
  coupons.parent.adminUser.sendToServer(
    "delete",
    "/coupons/" + id,
    function(res) {
      logs.print("coupons.del", res);
      if (res.status) {
        coupons.removeCoupon(id);
        coupons.parent.$toastr("success", coupons.parent.lang.delete_success);
      } else {
        coupons.parent.$toastr("error", coupons.parent.lang[res.error_msg]);
      }
      coupons.parent.pageLoading = false;
    },
    function() {}
  );
};
coupons.pause = function(id) {
  coupons.parent.adminUser.sendToServer(
    "post",
    "/coupons/" + id + "/pause",
    function(res) {
      logs.print("coupons.pause", res);
      if (res.status) {
        coupons.parent.$toastr("success", coupons.parent.lang.pause_success);
      } else {
        coupons.parent.$toastr(
          "error",
          coupons.parent.lang[res.error_msg] || res.error_msg
        );
      }
    },
    function() {}
  );
};
coupons.unpause = function(id) {
  coupons.parent.adminUser.sendToServer(
    "post",
    "/coupons/" + id + "/unpause",
    function(res) {
      logs.print("coupons.unpause", res);
      if (res.status) {
        coupons.parent.$toastr(
          "success",
          coupons.parent.lang.activated_success
        );
      } else {
        coupons.parent.$toastr(
          "error",
          coupons.parent.lang[res.error_msg] || res.error_msg
        );
      }
    },
    function() {}
  );
};
coupons.add = function(planID, name, qty, note, callback) {
  if (!note) note = "";
  logs.print("coupons.add");
  var list = coupons.parent.list;
  coupons.parent.adminUser.sendToServerData(
    "put",
    "/coupons",
    {
      planID: planID,
      qty: qty + "",
      name: name,
      note: note,
    },
    function(res) {
      logs.print("coupons.add", res);
      if (res.status) {
        if (callback && res.data && res.data) callback(res.data);
        coupons.parent.$toastr("success", coupons.parent.lang.added_success);
      } else {
        coupons.parent.$toastr(
          "error",
          coupons.parent.lang[res.error_msg] || res.error_msg
        );
        // console.error("coupons.add", res.error_msg)
      }
      coupons.parent.pageLoading = false;
    },
    function() {}
  );
};

coupons.getCustomer = function() {
  logs.print("getBalance");
  coupons.parent.adminUser.sendToServer(
    "get",
    "/billing/customer",
    function(res) {
      logs.print("coupons.getCustomer", res);
      if (res.status) {
        coupons.parent.customer = res.data;
      } else {
        console.error("customer", res.error_msg);
      }

      // coupons.parent.pageLoading = false;
    },
    function() {}
  );
};

export { coupons };
